'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:cardpointeTokenizer
 * @description
 * # cardpointeTokenizer
 * Minimalist directive to embed the CardPointe Hosted iFrame Tokenizer
 * and output the token via two-way binding.
 *
 * @param {string} token Output binding for the received token (e.g., token="parentScopeTokenVariable").
 */
angular.module('360StoreAngularApp')
	.directive('cardpointeTokenizer', function ($window, CARDPOINTE_TOKENIZER_HOST) {
		// CSS goes through CardPointe's css-sanitize endpoint; the newer sanitizer (UAT today, production eventually) rejects
		// double quotes anywhere in the stylesheet, so font names and the attribute selector use single quotes (%27)
		const tokenizerSrc = CARDPOINTE_TOKENIZER_HOST + '/itoke/ajax-tokenizer.html?sendcssloadedevent=true&useexpiry=true&usecvv=true&tokenizewheninactive=true&css=body%2Cform%7Bfont-family%3A-apple-system%2CBlinkMacSystemFont%2C%27Segoe%20UI%27%2CRoboto%2C%27Helvetica%20Neue%27%2CArial%2Csans-serif%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bcolor%3A%23333%3Bmargin%3A0%3Bpadding%3A0%7Dlabel%7Bdisplay%3Ainline-block%3Bmargin-bottom%3A2px%3Bfont-weight%3Abold%3Bcolor%3A%23333%7Dinput%5Btype%3D%27tel%27%5D%2Cselect%7Bbox-sizing%3Aborder-box%3Bdisplay%3Ainline-block%3Bheight%3A34px%3Bpadding%3A6px%2012px%3Bfont-size%3A14px%3Bline-height%3A1.42857143%3Bcolor%3A%23555%3Bbackground-color%3A%23fff%3Bborder%3A1px%20solid%20%23ccc%3Bborder-radius%3A4px%3Bvertical-align%3Amiddle%3Bmargin-bottom%3A5px%7Dinput%23ccnumfield%7Bwidth%3A20ch%7Dselect%23ccexpirymonth%7Bwidth%3Aauto%3Bmin-width%3A65px%3Bmargin-right%3A5px%7Dselect%23ccexpiryyear%7Bwidth%3Aauto%3Bmin-width%3A80px%7Dinput%23cccvvfield%7Bmax-width%3A70px%7D.error%2Cinput.error%2Cselect.error%7Bborder-color%3A%23a94442!important%7D';
		return {
			restrict: 'E',
			scope: {
				token: '=', // Two-way binding for the token output
			},
			template: `
          <div class="cardpointe-tokenizer-container">
              <iframe
                  id="tokenFrame"
                  name="tokenFrame"
                  style="width: 100%; height: 200px; border: none;">
              </iframe>
          </div>
      `,
			link: function (scope, element) {
				element.find('iframe')[0].src = tokenizerSrc;

				// --- postMessage Listener ---
				function handleCardPointeMessage(event) {
					const EXPECTED_CARDPOINTE_ORIGIN = CARDPOINTE_TOKENIZER_HOST;
					if (!event.origin || !event.origin.startsWith(EXPECTED_CARDPOINTE_ORIGIN)) {
						if (!event.origin?.includes('localhost') && !event.origin.includes('360works.com')) {
							console.warn('CardPointe Tokenizer: Message received from unexpected origin:', event.origin);
						}
						return;
					}

					if (typeof event.data !== 'string') {
						return;
					}
					let data;
					try {
						data = JSON.parse(event.data);
					} catch (e) {
						console.error('CardPointe Tokenizer: Could not parse message:', event.data, e);
						return;
					}

					scope.$applyAsync(function () { // Use $applyAsync or $apply
						if (data.hasOwnProperty('message')) {
							// Update the bound token value, whether it's a real token or empty
							if (scope.token !== data.message) {
								console.debug('CardPointe Tokenizer: Token updated/received.');
								scope.token = data.message;
							}
						} else if (data.hasOwnProperty('cssLoaded')) {
							console.debug('CardPointe iFrame CSS loaded.');
						} else {
							console.info('CardPointe Tokenizer: Received unhandled message type:', data);
						}
					});
				}

				// --- Add Listener ---
				console.debug('CardPointe Tokenizer: Adding message listener.');
				$window.addEventListener('message', handleCardPointeMessage);

				// --- Cleanup ---
				scope.$on('$destroy', function () {
					console.debug('CardPointe Tokenizer: Removing message listener.');
					$window.removeEventListener('message', handleCardPointeMessage);
				});

			}
		};
	});
